/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.23.0
 * @since 1.11.0
 */

import type { CSSProperties, Dispatch, FC, SetStateAction } from 'react';
import { memo, useCallback } from 'react';

import Highlighter from 'react-highlight-words';

import { EllipseText } from '../index';
import { InputSearchFoundItemStyled } from './styled/InputSearchStyled';
import type { IInputSearchItem } from './types';

export interface IFoundItemProps {
  item: IInputSearchItem;
  style?: CSSProperties;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onSelect: (item: IInputSearchItem) => void;
}

export const FoundItem: FC<IFoundItemProps> = ({
  item,
  style,
  setOpen,
  onSelect,
}) => {
  const handleClick = useCallback(() => {
    onSelect(item);
    setOpen(false);
  }, [item, onSelect, setOpen]);

  const { match, value } = item;

  return (
    <InputSearchFoundItemStyled style={style} onClick={handleClick}>
      <EllipseText>
        <Highlighter
          autoEscape={true}
          highlightClassName="input-search__found-item-highlight"
          searchWords={[match]}
          textToHighlight={value}
        />
      </EllipseText>
    </InputSearchFoundItemStyled>
  );
};

export const FoundItemMemo = memo(FoundItem);
